import { IDEContext } from '@/contexts/ide-context-types';
import { useContext } from 'react';

export const useIDEState = () => {
    const context = useContext(IDEContext);
    if (!context) {
        throw new Error('useIDEState must be used within an IDEProvider');
    }
    return context;
};
